import { Button, Modal } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../../../../AppContext';
import { GA_EVENT, GA_LABEL } from '../../../../../../common/constants';
import { Event } from '../../../../../../common/trackEvents';
import useRouter from '../../../../../../common/useRouter';

const DeleteUserModal = ({
  showModal = false,
  setShowModal,
  title,
  // name, commented for future use
  deleteProjectUser,
  mutationId,
  setMutationId,
  fetchProjectUser,
}) => {
  const {
    params: { projectId },
  } = useRouter();
  const { getCurrentUser } = useContext(AppContext);
  const currentUser = getCurrentUser();
  const handleOk = () => {
    deleteProjectUser({
      variables: {
        id: mutationId,
      },
    })
      .then(() => {
        Event(GA_EVENT.DELETE_PROJECT_USER, {
          label: GA_LABEL.DELETE_PROJECT_USER,
          // eslint-disable-next-line no-undef
          pathname: window?.location?.href,
          project_id: projectId,
          project_user_id: mutationId,
          user_id: currentUser?.id,
          user_name: currentUser?.name,
          tenant_id: currentUser?.tenantUser?.tenant?.id,
          tenant_name: currentUser?.tenantUser?.tenant?.organizationName,
        });
        fetchProjectUser();
      })
      .catch((err) => {
        return err;
      });
    setShowModal(false);
  };

  const handleCancel = () => {
    setMutationId('');
    setShowModal(false);
  };
  return (
    <div>
      <Modal
        id="delete-user-modal"
        maskClosable={false}
        centered
        closable={false}
        footer={null}
        open={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <h2 id="delete-modal-title">{`Remove ${title}`}</h2>
        <p id="delete-modal-message">
          Any data related to this User will be visible only to Project/System
          Admins.
        </p>
        <div className="form-buttons">
          <Button
            id="delete-cancel-button"
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
          >
            No, Cancel
          </Button>
          <Button
            id="delete-confirm-button"
            shape="round"
            type="primary"
            className="save-button"
            onClick={handleOk}
          >
            Yes, Remove
          </Button>
        </div>
      </Modal>
    </div>
  );
};
export default DeleteUserModal;
